export enum BlankViewImageVariants {
  Worried = 'WORRIED',
  Neutral = 'NEUTRAL',
  Happy = 'HAPPY',
}

export type BlankViewImageVariant = `${BlankViewImageVariants}`

export enum BlankViewImageSizes {
  Small = 'SMALL',
  Large = 'LARGE',
}
export type BlankViewImageSize = `${BlankViewImageSizes}`

export interface ActionObject {
  text: string
  onClick: () => void
}
